export const fileToImage = file =>
  new Promise(resolve => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = event => {
      const image = new Image();
      image.src = event.target.result;
      image.onload = () => {
        resolve(image);
      };
    };
  });

export const dataUrlToImage = dataUrl =>
  new Promise(resolve => {
    const image = new Image();
    image.src = dataUrl;
    image.onload = () => {
      resolve(image);
    };
  });

export const createThumbnail = (image, width) =>
  new Promise(resolve => {
    const aspectRatio = 16 / 9;
    const height = width / aspectRatio;
    const { width: imageWidth, height: imageHeight } = image;
    const scale = Math.max(width / imageWidth, height / imageHeight);
    const startClippingX = width / 2 - (imageWidth / 2) * scale;
    const startClippingY = height / 2 - (imageHeight / 2) * scale;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    canvas.style.display = "none";

    ctx.drawImage(
      image,
      startClippingX,
      startClippingY,
      imageWidth * scale,
      imageHeight * scale
    );

    const dataURL = canvas.toDataURL("image/png");
    const base64ImgString = `data:image/png;base64,${dataURL.replace(
      /^data:image\/(png|jpg);base64,/,
      ""
    )}`;

    resolve(base64ImgString);
  });
